module.exports = __webpack_public_path__ + "img/chapter-1-thumb.2380594b.jpg";